import qs from 'qs'

const parseParams = (params) => {
    return qs.parse(params);
}

export { parseParams }